<!-- Footer --> 
<footer id="footer">
  <div class="inner">
    <div class="content">
      <section>
        <h3>About</h3>
        <p>Our mission is to train people in debate according to the parliamentary system written in Robert's Rules Of Order, Newly Revised. This process, first written down formally in 1876, contains the evolution of serveral hundred years of parlimenatary process, and represents the best process for groups of people to make fair decisions.
          Our goal is to prepare people in order that they become effective in local government, business or leadership using these tools. Our government is by the people and for the people, but this only functions correctly when the people understand HOW to participate. </p>
        <p>Knowledge is the first step. Skill is the second.</p>
      </section>
      <section>
        <h4>Purpose</h4>
        <ul class="alt">
          <li><a routerLink="/bootcamp">Train Process</a></li>  
          <li><a routerLink="/zoom">Teach Understanding</a></li>          
          <li><a routerLink="/bootcamp">Create Effective Debate</a></li>
          <li><a routerLink="/adv-class">Improve Skill</a></li>
        </ul>
      </section>
      <section>
        <h3>Contact Us</h3>
        <p>Questions? <a routerLink="/contactus" aria-label="Go to contact form">Send us a message through our contact form</a></p>
      </section>
      <section>
        <h4>Social</h4>
        <ul class="plain">
          <li><a href="https://t.me/+IypLWFm4Wgg2ZDEx" aria-label="Join our Telegram group for Robert's Rules discussions"><i class="icon fa-telegram">&nbsp;</i>Telegram For Robert's Rules</a></li>
        </ul>
      </section>
    </div>
  </div>
</footer>

<div id="copyright " class="copyright">
Copyright &copy; 2025 <a href="https://adsplat.me"> AdSplat, Inc.</a>.
</div>
